/**
 * @generated SignedSource<<0aa4bde3ab258fb665e89212828a925f>>
 * @relayHash 4e66a1ed92ecc98e74128ce3557c84b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CommentsSectionQueryWithoutReactionsQuery$variables = {
  contentId: string;
  first?: AGG$Long | null;
  offset?: string | null;
};
export type CommentsSectionQueryWithoutReactionsQuery$data = {
  readonly comments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null;
      readonly node: {
        readonly ancestors: ReadonlyArray<{
          readonly id: string;
        } | null>;
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType?: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        };
        readonly location: {
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly version: {
          readonly by: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly type: string | null;
          } | null;
          readonly friendlyWhen: string | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
    readonly totalCount: number | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly homepageId: string | null;
        readonly id: string | null;
      } | null;
      readonly subType: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type CommentsSectionQueryWithoutReactionsQuery = {
  response: CommentsSectionQueryWithoutReactionsQuery$data;
  variables: CommentsSectionQueryWithoutReactionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "offset"
  },
  {
    "kind": "Literal",
    "name": "confluenceCommentFilter",
    "value": {
      "commentState": "UNRESOLVED",
      "commentType": "FOOTER"
    }
  },
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ALL"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "FOOTER"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v5 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v7/*: any*/)
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v11 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionType"
    }
  ],
  "type": "KnownUser"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v17 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v18 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v15/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v20 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v22 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v23 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v24 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v27 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v28 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v30 = {
  "kind": "ScalarField",
  "name": "number"
},
v31 = {
  "kind": "ScalarField",
  "name": "when"
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/)
  ],
  "type": "KnownUser"
},
v33 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v34 = {
  "kind": "ScalarField",
  "name": "subType"
},
v35 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v36 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "homepageId"
    }
  ]
},
v37 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        },
        (v14/*: any*/)
      ]
    },
    (v7/*: any*/)
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v38 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentsSectionQueryWithoutReactionsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v32/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v33/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              (v7/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v9/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v37/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentsSectionQueryWithoutReactionsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v9/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v32/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v33/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              (v7/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v9/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v32/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v37/*: any*/)
    ]
  },
  "params": {
    "cacheID": "4e66a1ed92ecc98e74128ce3557c84b1",
    "id": "8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c",
    "metadata": {},
    "name": "CommentsSectionQueryWithoutReactionsQuery",
    "operationKind": "query",
    "text": "query CommentsSectionQueryWithoutReactionsQuery($offset:String,$first:Long,$contentId:ID!){comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
  }
};
})();

(node as any).hash = "c124efaee0103dd309c2e510586b845f";

export default node;
